import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {User} from "../../model/user";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {UserService} from "./user.service";



@Injectable()
export class UserResolver implements Resolve<User>{
  private userKey;

  constructor(
    private userService:UserService
  ){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {

      this.userKey = route.params['id'];


      const user$ = this.userService.getUserByKey(this.userKey)
        .first();


      return user$;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/user/user-resolver.ts